import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IEventLog } from '../../../../model/event-logs';

@Component({
    selector: 'app-event-log-detail-dialog',
    templateUrl: './event-log-detail-dialog.component.html',
    styleUrls: ['./event-log-detail-dialog.component.scss']
})
export class EventLogDetailDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<EventLogDetailDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public eventLog: IEventLog
    ) {}
}
